// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainElement } from './TrainElement';
import {
    TrainElementFromJSON,
    TrainElementFromJSONTyped,
    TrainElementToJSON,
    TrainElementToJSONTyped,
} from './TrainElement';
import type { BoardingPosition } from './BoardingPosition';
import {
    BoardingPositionFromJSON,
    BoardingPositionFromJSONTyped,
    BoardingPositionToJSON,
    BoardingPositionToJSONTyped,
} from './BoardingPosition';

/**
 * An elementary component of a `Train` as an instance of a correspondent `TrainElement` on a concrete `ServiceJourney`, where specific values at each `ScheduledStopPoint` for this unique formation on an operation-day, may have its dynamic state (like section or exitSide).
 * @export
 * @interface TrainComponent
 */
export interface TrainComponent {
    /**
     * Label on the `TrainElement`, typically a number visible by passenger close to the boarding door.
     * @type {string}
     * @memberof TrainComponent
     */
    label?: string;
    /**
     * Occupancy prognosed on a daily basis (not a realtime fact, overall 1st and/or 2nd class).<br>x-extensible-enum: [LOW,MEDIUM,HIGH,UNKNOWN]
     * @type {string}
     * @memberof TrainComponent
     */
    occupancy: string;
    /**
     * Determines if a passenger may pass (de: Durchgang) to the previous car within formation.
     * @type {boolean}
     * @memberof TrainComponent
     */
    previousPassage: boolean;
    /**
     * Determines if a passenger may pass (de: Durchgang) to the next car within the formation.
     * @type {boolean}
     * @memberof TrainComponent
     */
    nextPassage: boolean;
    /**
     * true: icon for no passage should be displayed between this car and the next one (from left to right).
     * @type {boolean}
     * @memberof TrainComponent
     */
    displayNoPassageIcon: boolean;
    /**
     * true: For unknown reasons the car is not usable for passengers: false: Open or unknown.
     * @type {boolean}
     * @memberof TrainComponent
     */
    closed: boolean;
    /**
     * true: the restaurant is attended, false: the restaurant is not attended, null: no restaurant on this car
     * @type {boolean}
     * @memberof TrainComponent
     */
    restaurantAttended?: boolean;
    /**
     * 
     * @type {TrainElement}
     * @memberof TrainComponent
     */
    element: TrainElement;
    /**
     * 
     * @type {BoardingPosition}
     * @memberof TrainComponent
     */
    boardingPosition?: BoardingPosition;
    /**
     * 
     * @type {Set<string>}
     * @memberof TrainComponent
     */
    attributesAdvertised: Set<string>;
}

/**
 * Check if a given object implements the TrainComponent interface.
 */
export function instanceOfTrainComponent(value: object): value is TrainComponent {
    if (!('occupancy' in value) || value['occupancy'] === undefined) return false;
    if (!('previousPassage' in value) || value['previousPassage'] === undefined) return false;
    if (!('nextPassage' in value) || value['nextPassage'] === undefined) return false;
    if (!('displayNoPassageIcon' in value) || value['displayNoPassageIcon'] === undefined) return false;
    if (!('closed' in value) || value['closed'] === undefined) return false;
    if (!('element' in value) || value['element'] === undefined) return false;
    if (!('attributesAdvertised' in value) || value['attributesAdvertised'] === undefined) return false;
    return true;
}

export function TrainComponentFromJSON(json: any): TrainComponent {
    return TrainComponentFromJSONTyped(json, false);
}

export function TrainComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainComponent {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'occupancy': json['occupancy'],
        'previousPassage': json['previousPassage'],
        'nextPassage': json['nextPassage'],
        'displayNoPassageIcon': json['displayNoPassageIcon'],
        'closed': json['closed'],
        'restaurantAttended': json['restaurantAttended'] == null ? undefined : json['restaurantAttended'],
        'element': TrainElementFromJSON(json['element']),
        'boardingPosition': json['boardingPosition'] == null ? undefined : BoardingPositionFromJSON(json['boardingPosition']),
        'attributesAdvertised': new Set(json['attributesAdvertised']),
    };
}

  export function TrainComponentToJSON(json: any): TrainComponent {
      return TrainComponentToJSONTyped(json, false);
  }

  export function TrainComponentToJSONTyped(value?: TrainComponent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'occupancy': value['occupancy'],
        'previousPassage': value['previousPassage'],
        'nextPassage': value['nextPassage'],
        'displayNoPassageIcon': value['displayNoPassageIcon'],
        'closed': value['closed'],
        'restaurantAttended': value['restaurantAttended'],
        'element': TrainElementToJSON(value['element']),
        'boardingPosition': BoardingPositionToJSON(value['boardingPosition']),
        'attributesAdvertised': Array.from(value['attributesAdvertised'] as Set<any>),
    };
}

